import styled from 'styled-components';
import tw from 'twin.macro';
import { Body, Meta } from '../../styled components/Typography';

export const LoadingStateWrapper = styled.div.attrs(() => ({
  $absolute: true
}))(() => [tw`z-100`]);

export const EndOfRosterTitle = styled(Body).attrs(() => ({
  as: 'p',
  $textStyle: 'italic'
}))(() => [tw`text-blue-base text-opacity-95`]);

export const EndOfRosterText = styled(Meta).attrs(() => ({
  as: 'p'
}))(() => [tw`mt-24`]);
